// Popup de captura de email: nace oculto (hidden), se abre tras el delay
// configurado y respeta la frecuencia de reaparición vía localStorage.
// Custom element para que se re-inicialice solo cuando el editor de temas
// re-renderiza la sección.
(function () {
  if (customElements.get('infy-popup')) return;

  var KEY = 'infy-popup-dismissed';
  var DAY_MS = 86400000;

  function dismissedAt() {
    try {
      return parseInt(localStorage.getItem(KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function rememberDismissed() {
    try {
      localStorage.setItem(KEY, String(Date.now()));
    } catch (e) {
      // Modo privado / storage bloqueado: fallar en silencio.
    }
  }

  customElements.define(
    'infy-popup',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.infy-popup__dialog');
        this.designMode = !!(window.Shopify && window.Shopify.designMode);
        this.handleKeydown = this.handleKeydown.bind(this);

        var self = this;
        this.querySelectorAll('[data-infy-popup-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            self.close();
          });
        });

        var copyButton = this.querySelector('[data-infy-popup-copy]');
        if (copyButton) copyButton.addEventListener('click', this.copyCode.bind(this));

        if (this.designMode) {
          // En el editor: abrir/cerrar al seleccionar la sección, sin timers ni localStorage.
          var sectionEl = this.closest('.shopify-section');
          document.addEventListener('shopify:section:select', function (e) {
            if (e.target === sectionEl) self.open();
          });
          document.addEventListener('shopify:section:deselect', function (e) {
            if (e.target === sectionEl) self.close();
          });
          return;
        }

        if (this.getAttribute('data-enabled') !== 'true') return;

        // Redirect post-submit: mostrar de inmediato el éxito (con el código) o el error.
        if (this.querySelector('[data-infy-popup-success]')) {
          rememberDismissed();
          this.open();
          return;
        }
        if (this.querySelector('[data-infy-popup-error]')) {
          this.open();
          return;
        }

        var days = parseInt(this.getAttribute('data-frequency'), 10) || 15;
        if (Date.now() - dismissedAt() < days * DAY_MS) return;

        var delay = (parseInt(this.getAttribute('data-delay'), 10) || 6) * 1000;
        this.timer = setTimeout(function () {
          self.open();
        }, delay);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.classList.remove('overflow-hidden');
      }

      open() {
        if (!this.hidden) return;
        this.lastFocused = document.activeElement;
        this.hidden = false;
        var self = this;
        // Doble rAF para que la transición CSS corra desde el estado oculto.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            self.classList.add('infy-popup--open');
          });
        });
        document.addEventListener('keydown', this.handleKeydown);
        document.body.classList.add('overflow-hidden');
        this.dialog.focus();
      }

      close() {
        if (this.hidden) return;
        if (!this.designMode) rememberDismissed();
        this.classList.remove('infy-popup--open');
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.classList.remove('overflow-hidden');
        var self = this;
        setTimeout(function () {
          self.hidden = true;
        }, 200); // coincide con la transición CSS
        if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        // Focus trap simple: mantener Tab dentro del diálogo.
        var focusable = this.dialog.querySelectorAll(
          'button, [href], input, [tabindex]:not([tabindex="-1"])'
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      copyCode(event) {
        var code = this.querySelector('[data-infy-popup-code]');
        var button = event.currentTarget;
        if (!code) return;
        var text = code.textContent.trim();
        var done = function () {
          var original = button.textContent;
          button.textContent = button.getAttribute('data-copied-label') || original;
          setTimeout(function () {
            button.textContent = original;
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, function () {
            // Sin permiso de clipboard: fallar en silencio (el código queda visible).
          });
        } else {
          // ponytail: fallback execCommand para navegadores viejos; quitar cuando ya no importe.
          try {
            var area = document.createElement('textarea');
            area.value = text;
            document.body.appendChild(area);
            area.select();
            document.execCommand('copy');
            document.body.removeChild(area);
            done();
          } catch (e) {
            // Silencioso.
          }
        }
      }
    }
  );
})();
